export const GREETING_TEXT = "Congratulations!";
export const BOOKING_STATUS = {
    CONFIRMED: "confirmed",
    PENDING: "pending",
    RESERVED: "reserved",
    CANCELLED: "cancelled",
    COMPLETED: "completed",
    FAILED: "failed",
};
export const COLOR_KEYS = {
    POSITIVE: "positive",
    NEGATIVE: "negative",
    HIGHLIGHT: "highlight",
    HIGHEST_EMPHASIS: "text_Highest_Emphasis",
};
export const STATUS_DESCRIPTION = {
    PENDING: "It might take up to 1 hour for the restaurant to confirm.",
    CONFIRMED: "You are now a One Lite member.",
};
export const STATUS_TEXT = {
    CONFIRMED: "Your {0} is booked!",
    PENDING: "{0} confirmation in progress!",
    RESERVED: "Booking is reserved",
    CANCELLED: "Booking cancelled",
    FAILED: "Booking Failed!",
};

export const STEAL_DEAL_STATUS_TEXT = {
    CONFIRMED: "Order successful",
    PENDING: "Order confirmation in progress!",
    CANCELLED: "Order cancelled",
    FAILED: "Order Failed!",
};

export const GREEN_TICK_BACKGROUND_IMAGE =
    "MERCHANDISING_BANNERS/IMAGES/MERCH/2026/Tick.png?updatedAt=1785318683147";
export const WHAT_TO_DO_NEXT_IMAGE = "MERCHANDISING_BANNERS/IMAGES/MERCH/2026/What_to_do_next_.png";

export const DEFAULT_BACKGROUND_FOR_TABLE_BOOKING = {
    CONFIRMED: GREEN_TICK_BACKGROUND_IMAGE,
    CANCELLED: "MERCHANDISING_BANNERS/IMAGES/MERCH/2026/Cancelled.png?updatedAt=1785318683953",
    PENDING: "MERCHANDISING_BANNERS/IMAGES/MERCH/2026/Awaiting.png?updatedAt=1785318683873",
};

export const DEFAULT_BACKGROUND_FOR_EVENT_BOOKING = {
    CONFIRMED: "dineout/bg_Tick.png",
    CONFIRMED_DARK: "dineout/bg_Tick_dark.png",
    CANCELLED: "dineout/bookingCancelled.png",
    PENDING: "dineout/bookingPending.png",
};

export const DEFAULT_BACKGROUND_FOR_STEAL_DEAL = {
    CONFIRMED: "portal/static-assets/images/dineout/confirm.png",
    CANCELLED: "portal/static-assets/images/dineout/cancel.png",
    PENDING: "portal/static-assets/images/dineout/pending.png",
};

export const BANNER_HEIGHT = {
    DEFAULT: "245px",
    WITH_SUBSCRIPTION_META: "280px",
    COMPLETE_IMAGE_WITH_CONTENT: "300px",
};

export const TABLE_BOOKING_STATUS_DETAILS = {
    [BOOKING_STATUS.CONFIRMED]: {
        TEXT: STATUS_TEXT.CONFIRMED,
        DESCRIPTION: STATUS_DESCRIPTION.CONFIRMED,
        BACKGROUND: DEFAULT_BACKGROUND_FOR_TABLE_BOOKING.CONFIRMED,
    },
    [BOOKING_STATUS.PENDING]: {
        TEXT: STATUS_TEXT.PENDING,
        DESCRIPTION: STATUS_DESCRIPTION.PENDING,
        BACKGROUND: DEFAULT_BACKGROUND_FOR_TABLE_BOOKING.PENDING,
    },
    [BOOKING_STATUS.CANCELLED]: {
        TEXT: STATUS_TEXT.CANCELLED,
        DESCRIPTION: "",
        BACKGROUND: DEFAULT_BACKGROUND_FOR_TABLE_BOOKING.CANCELLED,
    },
    [BOOKING_STATUS.COMPLETED]: {
        TEXT: STATUS_TEXT.CONFIRMED,
        DESCRIPTION: STATUS_DESCRIPTION.CONFIRMED,
    },
    [BOOKING_STATUS.FAILED]: {
        TEXT: STATUS_TEXT.FAILED,
        DESCRIPTION: "",
    },
};

export const EVENT_BOOKING_STATUS_DETAILS = {
    [BOOKING_STATUS.CONFIRMED]: {
        TEXT: STATUS_TEXT.CONFIRMED,
        DESCRIPTION: STATUS_DESCRIPTION.CONFIRMED,
        BACKGROUND: {
            dark: DEFAULT_BACKGROUND_FOR_EVENT_BOOKING.CONFIRMED_DARK,
            light: DEFAULT_BACKGROUND_FOR_EVENT_BOOKING.CONFIRMED,
        },
    },
    [BOOKING_STATUS.PENDING]: {
        TEXT: STATUS_TEXT.PENDING,
        DESCRIPTION: STATUS_DESCRIPTION.PENDING,
        BACKGROUND: {
            dark: DEFAULT_BACKGROUND_FOR_EVENT_BOOKING.PENDING,
            light: DEFAULT_BACKGROUND_FOR_EVENT_BOOKING.PENDING,
        },
    },
    [BOOKING_STATUS.RESERVED]: {
        TEXT: STATUS_TEXT.RESERVED,
        DESCRIPTION: "",
        BACKGROUND: {
            dark: DEFAULT_BACKGROUND_FOR_EVENT_BOOKING.CONFIRMED_DARK,
            light: DEFAULT_BACKGROUND_FOR_EVENT_BOOKING.CONFIRMED,
        },
    },
    [BOOKING_STATUS.CANCELLED]: {
        TEXT: STATUS_TEXT.CANCELLED,
        DESCRIPTION: "",
        BACKGROUND: {
            dark: DEFAULT_BACKGROUND_FOR_EVENT_BOOKING.CANCELLED,
            light: DEFAULT_BACKGROUND_FOR_EVENT_BOOKING.CANCELLED,
        },
    },
    [BOOKING_STATUS.COMPLETED]: {
        TEXT: STATUS_TEXT.CONFIRMED,
        DESCRIPTION: STATUS_DESCRIPTION.CONFIRMED,
    },
    [BOOKING_STATUS.FAILED]: {
        TEXT: STATUS_TEXT.FAILED,
        DESCRIPTION: "",
    },
};

export const STEAL_DEAL_STATUS_DETAILS = {
    [BOOKING_STATUS.CONFIRMED]: {
        TEXT: STEAL_DEAL_STATUS_TEXT.CONFIRMED,
        DESCRIPTION: "",
        BACKGROUND: DEFAULT_BACKGROUND_FOR_STEAL_DEAL.CONFIRMED,
    },
    [BOOKING_STATUS.PENDING]: {
        TEXT: STEAL_DEAL_STATUS_TEXT.PENDING,
        DESCRIPTION: "",
        BACKGROUND: DEFAULT_BACKGROUND_FOR_STEAL_DEAL.PENDING,
    },
    [BOOKING_STATUS.CANCELLED]: {
        TEXT: STEAL_DEAL_STATUS_TEXT.CANCELLED,
        DESCRIPTION: "",
        BACKGROUND: DEFAULT_BACKGROUND_FOR_STEAL_DEAL.CANCELLED,
    },
    [BOOKING_STATUS.COMPLETED]: {
        TEXT: STEAL_DEAL_STATUS_TEXT.CONFIRMED,
        DESCRIPTION: "",
        BACKGROUND: DEFAULT_BACKGROUND_FOR_STEAL_DEAL.CONFIRMED,
    },
    [BOOKING_STATUS.FAILED]: {
        TEXT: STEAL_DEAL_STATUS_TEXT.FAILED,
        DESCRIPTION: "",
    },
};

export const BG_IMAGE = {
    HEIGHT: "320px",
};

export const STATUS_BANNER = {
    HEIGHT: {
        WITH_SUBSCRIPTION: "290px",
        WITH_DESCRIPTION: "255px",
        DEFAULT: "320px",
        EVENT_BOOKING: "400px",
    },
    MARGIN_TOP: "-40px",
    TEXT_WRAPPER_TOP: "140px",
};

export const STATUS_TEXT_STYLES = {
    SIZE: "35px",
    WEIGHT: 400,
    LINE_HEIGHT: "51px",
    LETTER_SPACING: "-0.3px",
};

export const DIVIDER_LENGTH = "220px";

export const BOOKING_ID_TEXT = "Booking ID: {0}";

export const EVENT_BOOKING_QR_TEXT = "Scan this QR code or share Booking ID at entrance for event entry";

export const TICKET_TEXT = {
    NORMAL: "ticket",
    CAPITAL: "Ticket",
};

export const TABLE_TEXT = {
    NORMAL: "table",
    CAPITAL: "Table",
};

export const BASE64_IMG_PREFIX = "data:image/png;base64,";

export const HELP_CTA_TEXT = "Help";

/* Currently the images being sent in PL are common across the new deal cart flow and the legacy RN flow.
 * During PP, there was a requirement to update the images for the new deal cart flow.
 * This is a temporary solution(to unblock XP rollout) to ensure that the updated images are shown 
 * instead of the actual images without affecting backward compatibility. 
TODO: remove this once the new deal cart flow is fully launched and PL is updated with the new images. */
export const SUCCESS_PAGE_IMAGE_URL_MAP: Record<string, string> = {
    // BANNER IMAGES
    "MERCHANDISING_BANNERS/IMAGES/MERCH/2024/7/10/1a1833c3-5c1a-4dd0-a66d-0a9f00972504_10869bf3c2755df3d48a33d0c3237c3f.png":
        "MERCHANDISING_BANNERS/IMAGES/MERCH/2026/Cancelled (1).png?updatedAt=1785318683771",

    "MERCHANDISING_BANNERS/IMAGES/MERCH/2024/8/30/fb13f70f-faae-4ba9-9494-53941f741ff1_image10.png":
        "MERCHANDISING_BANNERS/IMAGES/MERCH/2026/Cancelled (2).png?updatedAt=1785318683708",

    "rng/md/carousel/production/10869bf3c2755df3d48a33d0c3237c3f":
        "MERCHANDISING_BANNERS/IMAGES/MERCH/2026/Cancelled (1).png?updatedAt=1785318683771",

    "MERCHANDISING_BANNERS/IMAGES/MERCH/2024/7/12/160d1cee-0e2c-45b1-b9a5-d4b17f062b68_bookingexpiredu.png":
        "MERCHANDISING_BANNERS/IMAGES/MERCH/2026/Cancelled (3).png?updatedAt=1785318683749",

    "MERCHANDISING_BANNERS/IMAGES/MERCH/2024/7/29/08a46d0c-6709-4f9f-a2de-69b7ca1d6a27_PENDING1.png":
        "MERCHANDISING_BANNERS/IMAGES/MERCH/2026/pending variant 2.png?updatedAt=1785318683726",

    "MERCHANDISING_BANNERS/IMAGES/MERCH/2024/11/27/bf420707-b498-48f7-a667-d331a383fa62_107confirmationinprogress.png":
        "MERCHANDISING_BANNERS/IMAGES/MERCH/2026/One Black pending.png?updatedAt=1785318683718",

    "rng/md/carousel/production/feeccc2c6eda5c0d23e5fbb7033e832f":
        "MERCHANDISING_BANNERS/IMAGES/MERCH/2026/main pending.png?updatedAt=1785318683778",

    "rng/md/carousel/production/dd4e591ac51cd108dfb121d10fe99288":
        "MERCHANDISING_BANNERS/IMAGES/MERCH/2026/Table booked.png?updatedAt=1785318683698",

    "MERCHANDISING_BANNERS/IMAGES/MERCH/2024/7/18/cfc6187c-acfa-4a0d-9ccb-d8169bcf0bcc_Successpageheroimage.png":
        "MERCHANDISING_BANNERS/IMAGES/MERCH/2026/Rush Hour.png?updatedAt=1785318683781",

    "MERCHANDISING_BANNERS/IMAGES/MERCH/2024/11/27/ae32299f-1f4c-470c-993e-e9534bc66bf4_914669rushhourbooked.png": "", // no changes

    "rng/md/carousel/production/603b5e8627e3739727f773072430c541":
        "MERCHANDISING_BANNERS/IMAGES/MERCH/2026/Plain BG Green.png?updatedAt=1785318683655",

    "dineout/bg_Tick.png": GREEN_TICK_BACKGROUND_IMAGE,

    "dineout/one_black/blcksuccessscreenbg.png?updatedAt\u003d1731939702728":
        "MERCHANDISING_BANNERS/IMAGES/MERCH/2026/One BLCK Confirmed.png?updatedAt=1785318683684",

    // WHAT TO DO NEXT IMAGES
    "MERCHANDISING_BANNERS/IMAGES/MERCH/2024/8/21/17f88614-a34f-4182-9328-8ffa105da333_686b8d773ee0a3f070a4634b12e469dc.png":
        "MERCHANDISING_BANNERS/IMAGES/MERCH/2026/How_to_Redeem_.png",

    "rng/md/carousel/production/686b8d773ee0a3f070a4634b12e469dc":
        "MERCHANDISING_BANNERS/IMAGES/MERCH/2026/How_to_Redeem_.png",

    "rng/md/carousel/production/1d3c61b24d75d027e1b1e1b7476baa22": WHAT_TO_DO_NEXT_IMAGE,

    "MERCHANDISING_BANNERS/IMAGES/MERCH/2025/2/11/2116bc3f-7184-41cd-9046-6b84c2cf948f_howtoredeem.png": "", //OPEN

    "MERCHANDISING_BANNERS/IMAGES/MERCH/2024/7/19/a80c5a02-08fe-4483-95b0-9980bedaa33f_Whatnextrushhour.png":
        "MERCHANDISING_BANNERS/IMAGES/MERCH/2026/What_next2.png",

    "rng/md/carousel/production/a39c3cdd676896573aae8b6aab02c355":
        "MERCHANDISING_BANNERS/IMAGES/MERCH/2026/what_t_expect_.png",
};
